export const MODAL_DIALOG__VISITORS_CHART = 'MODAL_DIALOG__VISITORS_CHART';
export const MODAL_DIALOG__REVENUE_CHART = 'MODAL_DIALOG__REVENUE_CHART';
